import { downloadAuthenticatedDocument, downloadPublicDocument } from "../../../../../utils/blobDownload";
import { GetAllApiBaseUrls } from "../../../../../utils/getEnvironmentCurrent";

const isRelativeUrl = (docLink: string): boolean =>
    !/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(docLink) && !docLink.startsWith("//");

export const isAuthenticatedDocumentUrl = (docLink: string): boolean => {
    const envHosts = GetAllApiBaseUrls().map((url) => new URL(url).origin);
    try {
        const parsed = new URL(docLink, window.location.origin);
        if (isRelativeUrl(docLink)) {
            return parsed.pathname.startsWith("/api/");
        }
        return envHosts.includes(parsed.origin);
    } catch {
        return false;
    }
};

export const downloadInsightsDocument = async (
    docLink: string,
    fallbackFileName: string
): Promise<void> => {
    if (isAuthenticatedDocumentUrl(docLink)) {
        await downloadAuthenticatedDocument(docLink, fallbackFileName);
        return;
    }
    downloadPublicDocument(docLink);
};